import {
  ApiArtifactTheme,
  ApiArtifactGroup,
  ApiTag,
  ArtifactThemeSceneConfig,
} from "../../models/api";
import {
  ArtifactTheme,
  SceneItemConfig,
  Tag,
  ArtifactGroup,
  Artifact,
} from "../../models/client";
import { toArtifact } from "./artifact";
import { toImageConfig } from "./image";

export function apiArtifactThemeToArtifactTheme(
  artifactTheme: ApiArtifactTheme
): ArtifactTheme {
  return {
    id: artifactTheme.Slug,
    name: artifactTheme.Name,
    slug: artifactTheme.Slug,
    summary: artifactTheme.Summary,
    sceneItemConfig: apiSceneItemConfigToSceneItemConfig(
      artifactTheme.SceneItemConfig
    ),
    color: artifactTheme.Color,
    heroArtifact: toArtifact(artifactTheme.HeroArtifact, artifactTheme.Slug),
    dateTag: toTag(artifactTheme.DateTag),
    artifactGroups: artifactTheme.ArtifactGroups.map((apiArtifact) =>
      toArtifactGroup(apiArtifact, artifactTheme.Slug)
    ),
    otherObjects: artifactTheme.OtherObjects.map((apiArtifact) =>
      toArtifact(apiArtifact, artifactTheme.Slug)
    ),
  };
}

function apiSceneItemConfigToSceneItemConfig(
  apiSceneConfig: ArtifactThemeSceneConfig
): SceneItemConfig {
  return {
    position: { x: apiSceneConfig.Position.X, y: apiSceneConfig.Position.Y },
    image: toImageConfig(apiSceneConfig.Image),
    btnColor: apiSceneConfig.BtnColor,
    size: apiSceneConfig.Size,
    offsetPosition: apiSceneConfig.OffsetPosition,
  };
}

function toArtifactGroup(
  apiArtifactGroup: ApiArtifactGroup,
  themeId: number | string
): ArtifactGroup {
  return {
    id: apiArtifactGroup.Id,
    name: apiArtifactGroup.Name,
    tags: apiArtifactGroup.Tags,
    summary: apiArtifactGroup.Summary,
    artifacts: apiArtifactGroup.Artifacts.map((apiArtifact) =>
      toArtifact(apiArtifact, themeId)
    ),
  };
}

function toTag(apiTag: ApiTag): Tag {
  return {
    id: apiTag.Id,
    color: apiTag.Color,
    label: apiTag.Label,
  };
}

export function allArtifacts(artifactThemes: ArtifactTheme[]): Artifact[] {
  return artifactThemes.reduce((artifacts, artifactTheme) => {
    const themeArtifacts = artifactTheme.artifactGroups.reduce(
      (artifacts, artifactGroup) => {
        return [...artifacts, ...artifactGroup.artifacts];
      },
      [] as Array<Artifact>
    );

    return [...artifacts, artifactTheme.heroArtifact, ...themeArtifacts];
  }, [] as Array<Artifact>);
}
export function sortByKey<T>(items: T[], key: keyof T): T[] {
  return items.sort((a, b) => {
    const aTest = String(a[key]).toLowerCase();
    const bTest = String(b[key]).toLowerCase();

    if (aTest < bTest) {
      return -1;
    }
    if (aTest > bTest) {
      return 1;
    }
    return 0;
  });
}
